import "./index.css";

import { App } from "./components/App/App";
import { MsalProvider } from "@azure/msal-react";
import { PublicClientApplication } from "@azure/msal-browser";
import React from "react";
import ReactDOM from "react-dom";
import { msalConfig } from "./auth/authConfig";
import reportWebVitals from "./reportWebVitals";

const isClientIFRC = process.env.REACT_APP_CLIENT_NAME === "IFRC";
let msalInstance = null;

if (isClientIFRC) {
	msalInstance = new PublicClientApplication(msalConfig);
	if (
		!msalInstance.getActiveAccount() &&
		msalInstance.getAllAccounts().length > 0
	) {
		msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
	}
}

const renderApp = (
	<React.StrictMode>
		{isClientIFRC ? (
			<MsalProvider instance={msalInstance as PublicClientApplication}>
				<App />
			</MsalProvider>
		) : (
			<App />
		)}
	</React.StrictMode>
);

ReactDOM.render(renderApp, document.getElementById("root"));

reportWebVitals();
